import { DatePipe, DATE_PIPE_DEFAULT_TIMEZONE } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'localDate' })
export class LocalDatePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'M/d/yyyy');
    }
}

@Pipe({ name: 'localDateTime' })
export class LocalDateTimePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'M/d/yyyy h:mma');
    }
}

@Pipe({ name: 'localPrettyDate' })
export class LocalPrettyDatePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'MMMM d, yyyy');
    }
}

@Pipe({ name: 'localPrettyTime' })
export class LocalPrettyTimePipe implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'h:mma z');
    }
}

@Pipe({ name: 'localPrettyDateTime' })
export class LocalPrettyDatePipeTime implements PipeTransform {
    constructor(private dPipe: DatePipe) {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'MMMM d, yyyy h:mma z');
    }
}


@Pipe({ name: 'ordinal' })
export class OrdinalPipe implements PipeTransform {
    constructor() {
    }

    transform(value?: number) {
        if (!value) {
            return null;
        }
        if (value.toString().endsWith('11')) { return value.toString() + 'th'; }
        if (value.toString().endsWith('12')) { return value.toString() + 'th'; }
        if (value.toString().endsWith('13')) { return value.toString() + 'th'; }
        if (value.toString().endsWith('1')) { return value.toString() + 'st'; }
        if (value.toString().endsWith('2')) { return value.toString() + 'nd'; }
        if (value.toString().endsWith('3')) { return value.toString() + 'rd'; }
        return value.toString() + 'th';
    }
}

@Pipe({
    name: 'search'
}) export class SearchFilterPipe implements PipeTransform {
    transform(data: any[], filter: string): any {
        if (!data || !filter) {
            return data;
        }
        return data.filter(obj => {
            return Object.keys(obj).reduce((acc, curr) => {
                return acc || filter.split(' ').filter(f => { return f.trim().length > 0; }).filter(f => { return typeof (obj[curr]) == 'string' && obj[curr].toLowerCase().includes(f); }).length > 0;
            }, false);
        });
    }
}

@Pipe({
    name: 'filter',
    pure: false,
}) export class ObjectFilterPipe implements PipeTransform {
    transform(data: any[], filter: any): any {
        if (!data || !filter) {
            return data;
        }
        //console.log(filter);
        return data.filter(obj => {
            return Object.keys(filter).reduce((acc, curr) => {
                //                console.log(obj);
                //                console.log(obj.hasOwnProperty(curr) ? 'has ' + curr + ' ' + obj[curr] : 'missing ' + curr);
                if (filter[curr] === null || filter[curr] === undefined) {
                    return true;
                } else if (typeof filter[curr] == 'string') {
                    return obj.hasOwnProperty(curr) ? (obj[curr] || '').toLowerCase().indexOf(filter[curr].toLowerCase()) >= 0 : false;
                } else {
                    return obj.hasOwnProperty(curr) ? obj[curr] == filter[curr] : false;
                }
            }, false);
        });
    }
}
